import React, { useState } from 'react';
import Alerts from '../../../common/Alerts';
import { CenteredContainer, LoginWrap } from '../styledComponents';
import useQueryStringAlerts from '../../slices/hooks/useQueryStringAlerts';
import ForeFlightHeader from '../ForeFlightHeader';
import Footer from '../Footer';
import FormController from '../FormController';
import { usePassword, useUsername } from '../../slices/hooks/useUsersSlice';
import VerifyCode from '../PasswordReset/VerifyCode';
import UsernamePasswordForm from './UsernamePasswordForm';
import useForeFlightAuthentication from '../../slices/hooks/useForeFlightAuthentication';

const Login = () => {
    const [code, setCode] = useState<string>('');
    const { username, updateUsername } = useUsername();
    const { password, updatePassword } = usePassword();
    const [isPublicComputer, setIsPublicComputer] = useState<boolean>(false);
    const [isResendCodeDisabled, setIsResendCodeDisabled] = useState<boolean>(false);
    const alerts = useQueryStringAlerts();

    const {
        onAuthenticationRequirementsCheck,
        resendContactCodeEmail,
        isPasswordLoginAllowed,
        hasFetchedRequirements,
        onPasswordLogin,
        showVerifyCodeInput,
        isLoading,
        alerts: authAlerts,
        resetAlerts,
        reset,
    } = useForeFlightAuthentication();

    const disableResendCode = () => {
        setIsResendCodeDisabled(true);

        setTimeout(() => {
            setIsResendCodeDisabled(false);
        }, 60000); // 1 minute
    };

    const onResendContactCodeEmail = () => {
        if (isResendCodeDisabled) {
            return;
        }
        resetAlerts();
        resendContactCodeEmail();
        disableResendCode();
    };

    const onReset = () => {
        updateUsername('');
        updatePassword('');
        setCode('');
        setIsPublicComputer(false);
        setIsResendCodeDisabled(false);
        reset();
    };

    const handlePasswordLogin = (username: string, password: string) => {
        onPasswordLogin(username, password, isPublicComputer, code);
    };

    const onVerifyContactCode = (mfaCode: string) => {
        onPasswordLogin(username, password, isPublicComputer, mfaCode);
    };

    const isPasswordLoginShowing = isPasswordLoginAllowed && !showVerifyCodeInput;
    return (
        <LoginWrap>
            <CenteredContainer>
                <ForeFlightHeader
                    showWelcomeHeader={isPasswordLoginShowing}
                    username={username}
                    onReset={onReset}
                />
                <Alerts alerts={[...alerts, ...authAlerts]} />
                <UsernamePasswordForm
                    isHidden={showVerifyCodeInput}
                    onAuthenticationRequirementsCheck={onAuthenticationRequirementsCheck}
                    onPasswordLogin={handlePasswordLogin}
                    isLoading={isLoading}
                    isPasswordLoginAllowed={isPasswordLoginAllowed}
                    hasFetchedRequirements={hasFetchedRequirements}
                />
                <VerifyCode
                    show={showVerifyCodeInput}
                    code={code}
                    setCode={setCode}
                    isLoading={isLoading}
                    verifyContactCode={onVerifyContactCode}
                    onReset={onReset}
                />
                <FormController
                    isPasswordLoginShowing={isPasswordLoginShowing}
                    isMfaShowing={showVerifyCodeInput}
                    onResendCode={onResendContactCodeEmail}
                    isResendCodeDisabled={isResendCodeDisabled}
                    isPublicComputer={isPublicComputer}
                    onPublicChange={setIsPublicComputer}
                />
                <Footer />
            </CenteredContainer>
        </LoginWrap>
    );
};
export default Login;
